import { createFileRoute } from "@tanstack/react-router";

import { NetworkLandingPage } from "@/components/marketing/network-landing-page";
import { networkLandingHead } from "@/lib/seo";

/**
 * The landing copy is loaded, not imported at module scope: `head` is not
 * code-split, so a static import here would put every network door's copy in
 * the app's entry chunk for every visitor. See `help.$slug` for the same note.
 */
export const Route = createFileRoute("/(public)/tiktok-scheduler")({
  loader: async () => {
    const { NETWORK_LANDINGS } = await import(
      "@/components/marketing/network-landing-data"
    );
    return { landing: NETWORK_LANDINGS["tiktok-scheduler"] };
  },
  head: ({ loaderData }) =>
    loaderData ? networkLandingHead(loaderData.landing) : {},
  component: NetworkLandingRoute,
});

function NetworkLandingRoute() {
  const { landing } = Route.useLoaderData();
  return <NetworkLandingPage landing={landing} />;
}
